import { render } from "./AppWrapper.vue?vue&type=template&id=56921a66&scoped=true"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=56921a66&scoped=true&lang=scss"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56921a66"]])

export default __exports__